// extracted by mini-css-extract-plugin
export var colourBase = "OxwgDYaiRZSVXZjZTrJk";
export var colourDisabled = "jvTbQa1wjGZD6Vy2qAo2";
export var colourInverted = "jPtI_yTtksUGLyW5LFNL";
export var colourNegative = "G_KIQFVC29xhaLbplS9i";
export var colourPositive = "U7q7khLNL25oMcS06E2r";
export var colourSubdued = "vxIdTX5fXjsLYMFFmC0s";
export var colourSubtle = "ZCs1ZXrJZOBEXQ2AqitJ";
export var colourUrgencyHigh = "gwxIKNMb2LJXtazleGiX";
export var colourUrgencyMedium = "kMyxAwjgUAP7zcXIMeGd";
export var colourWarning = "nsj5gKSOuetjs9MT1nUp";
export var colourWhite = "ySAYaYFAKl6V6U4R50xa";